import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/metzeler_tire_free63_detail.jpg")